export const BETA_TESTER_AGREEMENT_ROUTE = '/beta-tester-agreement';

export interface PendingRequiredAgreement {
    agreementKey: string;
    agreementVersion: string;
    title: string;
    routePath: string;
}

export function getPrimaryPendingAgreement(pendingRequiredAgreements: PendingRequiredAgreement[]): PendingRequiredAgreement | null {
    return pendingRequiredAgreements[0] ?? null;
}

export function isAgreementRoute(pathname: string): boolean {
    return pathname === BETA_TESTER_AGREEMENT_ROUTE;
}

export function sanitizeAgreementRedirectTarget(
    redirectTarget: string | null | undefined,
    agreementRoutePath = BETA_TESTER_AGREEMENT_ROUTE
): string {
    if (!redirectTarget || redirectTarget.trim().length === 0) {
        return '/';
    }

    const trimmedRedirectTarget = redirectTarget.trim();

    if (!trimmedRedirectTarget.startsWith('/')) {
        return '/';
    }

    if (trimmedRedirectTarget.startsWith(agreementRoutePath)) {
        return '/';
    }

    return trimmedRedirectTarget;
}

export function buildAgreementRedirectPath(params: {
    pendingRequiredAgreements: PendingRequiredAgreement[];
    redirectTarget?: string | null;
}): string {
    const pendingAgreement = getPrimaryPendingAgreement(params.pendingRequiredAgreements);

    if (!pendingAgreement) {
        return sanitizeAgreementRedirectTarget(params.redirectTarget);
    }

    const normalizedRedirectTarget = sanitizeAgreementRedirectTarget(params.redirectTarget, pendingAgreement.routePath);

    return `${pendingAgreement.routePath}?redirect=${encodeURIComponent(normalizedRedirectTarget)}`;
}
